import { render, staticRenderFns } from "./PassengerSearchMapper.vue?vue&type=template&id=2f3b455e"
import script from "./PassengerSearchMapper.vue?vue&type=script&lang=ts"
export * from "./PassengerSearchMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports